import React, {useContext, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import s from './styles/Inbox.module.scss'
import {isMentee, isMentor, SessionContext} from 'Utils/sessions';
import SideBar from 'Components/Nav/SideBar';
import avi from 'Static/default-avi.png'
import {TextInput} from 'Input/Input';
import Button from 'react-bootstrap/esm/Button'
import {IoIosSend} from 'react-icons/io'
import Modal from 'react-bootstrap/Modal';
import {AdminApi} from "../Api/AdminApi";
import Linkify from 'react-linkify';

const Inbox = () => {
    const {session} = useContext(SessionContext)
    const [sending, setSending] = useState(false)
    const [thread, setThread] = useState(null)
    const [threadParticipant, setThreadParticipant] = useState(null)
    const [message, setMessage] = useState(null)
    const [messageError, setMessageError] = useState(null)
    const [threads, setThreads] = useState(null)
    const [threadsError, setThreadsError] = useState(null)
    const [show, setShow] = useState(false)

    const keyDown = (event) => {
        if (event.key === "Enter" && !!message && message.length > 0) {
            sendMessage();
        }
    }


    const scrollToBottom = () => {
        const webContainer = document.getElementById('webContainer');
        if (!(webContainer instanceof Element)) {
            return;
        }
        const webContainerStyle = window.getComputedStyle(webContainer);

        const mobileContainer = document.getElementById('mobileContainer');
        const mobileContainerStyle = window.getComputedStyle(mobileContainer);

        const messagesContainer = document.getElementById('messagesContainerRef');
        const mobileMessageContainer = document.getElementById('mobileMessagesContainerRef');

        const isMobileView = (webContainerStyle.display === 'none') && (mobileContainerStyle.display === 'block');

        if (messagesContainer && !isMobileView) {
            messagesContainer.lastElementChild.scrollIntoView({behavior: 'smooth', block: 'end'});
        } else if (mobileMessageContainer && isMobileView) {
            mobileMessageContainer.lastElementChild.scrollIntoView({behavior: 'smooth', block: 'end'});
        }
    };

    useEffect(() => {
        document.addEventListener('new-notification-received', (event) => {
            getThreads();
        });
    }, []);

    useEffect(() => {
        const sock = new SockJS(`${AdminApi.baseURL}/api/v2/notificationsocket`);
        const stompClient = Stomp.over(sock);
        stompClient.debug = function () { }; //do nothing
        stompClient.connect({'Authorization': `Bearer: ${session.jwt}`}, (frame) => {
            stompClient.subscribe(`/messaging/support/thread-notifications`, (response) => {
                updateThread();
            });
        });
    }, [threads, thread]);

    useEffect(() => {
        getThreads();
    }, [])

    useEffect(() => {
        if (thread) {
            scrollToBottom();
        }
    }, [thread, sending]); // Scroll whenever messages change

    useEffect(() => {
        if (!thread) {
            setThreadParticipant(null)
        } else {
            const participant = thread.user
            setThreadParticipant(participant)
        }
    }, [thread, session.userName])

    function sendMessage() {
        setMessageError(null)
        if (!message) {
            return
        }

        setSending(true)

        AdminApi.Messaging.sendSupportChatMessage({
            isUser: false,
            username: thread?.user?.username,
            message: message
        }, session.jwt).then(() => {
            setMessage(null)
            setMessageError(null)
            updateThread()
            setSending(false)
        }).catch(() => {
            setSending(false);
            setMessageError('Error sending message, please try again');
        });
    }

    function getThreads() {
        AdminApi.Messaging.getSupportChatThreads(session.jwt)
            .then((res) => {
                setThreads(res.data?.threads);
            })
            .catch((err) => {
                setThreadsError('Unable to get messages')
                setThreads([])
            });
    }

    function updateThread() {
        if (thread) {
            AdminApi.Messaging.getSupportChatThread(thread.user?.username, session.jwt)
                .then((res) => {
                    setThread(res.data);
                }).catch((err) => {
                console.log(err)
            })
        }
    }

    function markThreadAsRead(username) {
        AdminApi.Messaging.readSupportChatThread(username, session.jwt)
            .then(() => {
                // Create a new CustomEvent. The first argument is the event name.
                const myEvent = new CustomEvent('thread-marked-read');
                // Dispatch the event on the document:
                document.dispatchEvent(myEvent);
            }).catch((err) => {
            console.log(err)
        })
    }

    function isToday(ts) {
        var today = new Date().setHours(0, 0, 0, 0);
        var thatDay = new Date(ts).setHours(0, 0, 0, 0);
        return today === thatDay
    }

    const Tile = ({t}) => {
        const participant = t.user
        return <div className={`${s.threadTile} ${(thread && (t.id === thread.id)) && s.active}`}
                    onClick={() => {
                        markThreadAsRead(participant.username)
                        t.newMessage = false;
                        setThread(t);
                    }}>
            <div style={{margin: '5px'}}>
                {(t.newMessage) ? <div style={{
                    backgroundColor: '#108e73',
                    height: 10,
                    width: 10,
                    borderRadius: '50%',
                    marginRight: '10px'
                }}/> : <div style={{height: 10, width: 10, borderRadius: '50%', marginRight: '10px'}}/>}
            </div>
            <img src={participant.photo || avi}/>
            <span className='ms-2'>
      <p className='mb-0 fs-14'>{participant.firstName} {participant.lastName}</p>
      <p className='mb-0 fs-12 text-muted'>{new Date(t.messages?.length > 0 ? t.messages?.sort((a, b) => a.timestamp - b.timestamp
      ).slice(-1)[0].timestamp : t.startTime).toLocaleDateString("en-US", {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
      })}</p>
                <p className='mb-0 fs-14'>{t.messages.sort((a, b) => b.timestamp - a.timestamp)[0]?.message}</p>
    </span>
        </div>
    }

    return <div>
        <SideBar session={session} title={"Inbox"} search={true} placeholder={"Search for a past conversation"}
                 onSearch={() => {
                 }}>

            <div id="webContainer" className={`${s.grid} ${s.web}`}>
                <div className={`${s.threads}`}>
                    <h3>Chats</h3>
                    <hr className='my-0'/>
                    <div className={s.threadsContainer}>
                        {threads?.sort((a, b) => a.lastMessage?.timestamp - b.lastMessage?.timestamp).reverse().map((t, idx) => {
                            return <>
                                <Tile key={idx} t={t}/>
                                <hr className='my-0'/>
                            </>
                        })}
                    </div>
                </div>
                <div className={s.thread}>
                    {threadParticipant && <div className={s.header}>
                        <img src={threadParticipant.photo || avi}/>
                        {isMentor(threadParticipant) ? <Link to={`/mentors/${threadParticipant.userName}`}
                                                             className='btnLink ms-2'>{threadParticipant.firstName} {threadParticipant.lastName}</Link> :
                            <Button onClick={() => setShow(true)}
                                    className='ms-2 btnLink'>{threadParticipant.firstName} {threadParticipant.lastName}</Button>
                        }
                        {threadParticipant &&
                            <Modal show={show} onHide={() => setShow(false)}>
                                <Modal.Header closeButton/>
                                <Modal.Body>
                                    <img className="d-block mx-auto" src={threadParticipant.photo || avi}
                                         style={{
                                             height: '70px',
                                             width: '70px',
                                             objectFit: 'cover',
                                             borderRadius: '50%'
                                         }}/>
                                    <p className="text-center mt-1 mb-0 pb-0">{threadParticipant.firstName} {threadParticipant.lastName}</p>

                                    {isMentee(threadParticipant) &&
                                        <p className='fs-13 text-muted text-center'>Prospective College
                                            Student</p>}
                                    <p className='text-center fs-14'>{threadParticipant?.bio}</p>
                                </Modal.Body>
                            </Modal>}
                    </div>}


                    <div className={s.threadContent}>
                        <div className={s.threadsContainer} id="messagesContainerRef">
                            <div className={s.threadClearance}/>
                            {thread && thread.messages.sort((a, b) => a.timestamp - b.timestamp).map((m, idx) => {
                                return <>
                                    <div
                                        className={m.isUser ? s.msgRec : s.msgSent}>
                                          <span>
                                            <p className='mb-0'>
                                            {m.message}
                                            </p>
                                              {<span
                                                  className='fs-10 d-block mb-1 text-muted'>{isToday(m.timestamp) && new Date(m.timestamp).toLocaleTimeString([], {
                                                  hour: '2-digit',
                                                  minute: '2-digit'
                                              })}</span>}
                                          </span>
                                    </div>
                                </>
                            })}

                            <div id="messagesEndRef"/>
                            {/* Empty div at the bottom */}
                        </div>
                        {thread && <div onKeyDown={keyDown} className={s.input}>
                            <TextInput containerClassName='mb-1' errors={{'message': messageError}}
                                       name="message"
                                       value={message || ''} onChange={(e) => setMessage(e.target.value)}
                                       placeholder={'...'}/>
                            <Button disabled={sending} onClick={sendMessage}
                                    className='btnLink'><IoIosSend
                                size={25}/></Button>
                        </div>}
                    </div>
                </div>
            </div>

            <div id="mobileContainer" className={`${s.mobile}`}>
                {!thread &&
                    <>
                        <h3 className={'px-3 pt-3'}>Chats</h3>
                        <div className={s.threadsContainer}>
                            {threadsError && <p className='p-2 form-error'>{threadsError}</p>}

                            {threads && threads.map((t, idx) => {
                                return <>
                                    <Tile key={idx} t={t}/>
                                    <hr className='my-0'/>
                                </>
                            })}
                        </div>
                    </>
                }

                {threadParticipant &&
                    <div className={`${s.header} justify-content-between d-flex align-items-center`}>
                        <span>
                          <img src={threadParticipant.photo || avi} alt={''}/>
                            {isMentor(threadParticipant) ? <Link to={`/mentors/${threadParticipant.userName}`}
                                                                 className='btnLink ms-2'>{threadParticipant.firstName} {threadParticipant.lastName}</Link> :
                                <Button onClick={() => setShow(true)}
                                        className='ms-2 btnLink'>{threadParticipant.firstName} {threadParticipant.lastName}</Button>}
                        </span>
                        <span>
                            <Button className='btnLink' onClick={() => setThread(null)}>Back</Button>
                        </span>
                    </div>
                }

                <div className={s.thread}>
                    <div className={s.threadContent} id="mobileMessagesContainerRef">
                        {thread && thread.messages.sort((a, b) => a.timestamp - b.timestamp).map((m, idx) => {
                            return <>
                                <div className={m.isUser ? s.msgRec : s.msgSent}>
                                  <span>
                                    <p className='mb-0'>
                                    <Linkify>{m.message}</Linkify>
                                    </p>
                                      {<span
                                          className='fs-10 d-block mb-1 text-muted'>{isToday(m.timestamp) && new Date(m.timestamp).toLocaleTimeString([], {
                                          hour: '2-digit',
                                          minute: '2-digit'
                                      })}</span>}
                                  </span>
                                </div>
                            </>
                        })}


                        <div id="mobileMessagesEndRef"/>
                        {/* Empty div at the bottom */}
                    </div>
                </div>
                {thread && <div onKeyDown={keyDown} className={s.mobileInput}>
                    <TextInput containerClassName='mb-1' errors={{'message': messageError}} name="message"
                               value={message || ''} onChange={(e) => setMessage(e.target.value)} placeholder={'...'}/>
                    <Button disabled={sending} onClick={sendMessage}
                            className='btnLink'><IoIosSend size={25}/></Button>
                </div>}
            </div>
        </SideBar>
    </div>
}

export default (Inbox);
